/**
 * The next document when colleagues share a job. Paige's server chooses it (ADR-0009): the review screen
 * sends the documents asked about, after the open one and then wrapping, and gets back the first one no
 * colleague holds. Until 2026-10-31 this file also kept the Needs review list's own order (owner,
 * 2026-10-01); that list went with CapturePoint's one list of every document (5435f5aa), whose Next is
 * the document after the open one, wrapping.
 */
/** What the reviewer is told when Paige passed over documents a colleague holds to reach this one. */
export function passedOverNotice(
  candidates: readonly string[],
  opened: string,
  holderOf: (documentId: string) => string | undefined,
): string | null {
  const passed = candidates.slice(0, Math.max(0, candidates.indexOf(opened)));
  if (passed.length === 0) return null;
  const names = [...new Set(passed.map((id) => holderOf(id) ?? 'a colleague'))];
  const who = names.length === 1 ? names[0] : 'colleagues';
  return passed.length === 1
    ? `The next document is with ${who}, so Paige opened the one after it`
    : `${passed.length} documents ahead of this one are with ${who}, so Paige opened this one`;
}
